<template>
  <div>
    <Loader
      v-show="loading"
      :loading="loading"
    />
    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <span class="headline font-weight-medium">{{ header }}</span>
          <v-spacer />
          <IconBtn
            icons="close"
            :large="true"
            color="grey darken-4"
            @click="close"
          />
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <ClientSelect
              v-model="client"
              label="Контрагент"
              :required="true"
              :error-messages="$v.client.$invalid ? errors.REQUIRED : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <ProductSelect
              v-model="product"
              label="Товар"
              :required="true"
              :error-messages="$v.product.$invalid ? errors.REQUIRED : []"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <DecimalEditor
              v-model="amount"
              label="Кількість"
              scale="0"
              :hide-details="true"
              :required="true"
              :error-messages="$v.amount.$invalid ? errors.REQUIRED : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <DecimalEditor
              v-model="price"
              label="Ціна"
              scale="2"
              :hide-details="true"
              :required="true"
              :error-messages="$v.price.$invalid ? errors.REQUIRED : []"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <DatePicker
              v-model="date"
              default-value
              :filled="false"
              label="Дата"
              :hide-details="true"
              :required="true"
              :error-messages="$v.date.$invalid ? errors.REQUIRED : []"
              @input="isChanged = true"
            />
          </v-col>
          <v-col>
            <UserSelect
              v-model="user"
              :multiple-select="false"
              label="Відповідальний*"
              placeholder="Введіть iм’я виконавця"
              :disabled="true"
              @input="isChanged = true"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="description"
              outlined
              label="Коментар"
              :hide-details="true"
              rows="2"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <PrimaryBtn
          :loading="loading"
          :disabled="!isChanged || isFormInvalid"
          @click="save"
        />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as productConsumptionsApi from "../../backend/productConsumptionsApi.js";
import Loader from "../../../components/Loader.vue";
import IconBtn from "../../../components/IconBtn.vue";
import PrimaryBtn from "../../../components/PrimaryBtn.vue";
import DecimalEditor from "@/components/DecimalEditor.vue";
import ClientSelect from "../clients/ClientSelect.vue";
import { ERRORS } from "@/helpers";
import { required, minValue } from "vuelidate/lib/validators";
import ProductSelect from "../products/ProductsSelect.vue";
import DatePicker from "@/components/story/DatePicker";
import UserSelect from "../../../views/system/users/UserSelect.vue";
import authApi from "../../../auth.js";

export default {
  components: {
    Loader,
    IconBtn,
    PrimaryBtn,
    ClientSelect,
    ProductSelect,
    DecimalEditor,
    DatePicker,
    UserSelect,
  },
  props: ["id"],
  data: () => ({
    loading: false,
    isChanged: false,
    client: null,
    product: null,
    amount: 0,
    price: 0,
    description: "",
    date: "",
    user: null,
  }),
  validations: {
    client: {
      required,
    },
    product: {
      required,
    },
    amount: {
      required,
      minValue: minValue(1),
    },
    price: {
      required,
      minValue: minValue(1),
    },
    date: {
      required,
    },
  },
  computed: {
    isFormInvalid(){
      return this.$v.client.$invalid ||
       this.$v.product.$invalid ||
        this.$v.amount.$invalid ||
        this.$v.price.$invalid ||
        this.$v.date.$invalid;
    },

    isNew() {
      return this.id != 0 ? false : true;
    },
    header() {
      return this.isNew ? "Створення витрати товару" : "Редагування витрати товару";
    },
    errors() {
      return {
        REQUIRED: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (!this.isNew) {
      productConsumptionsApi.getProductConsumption(this.id).then((entity) => {
        this.client = entity.client;
        this.product = entity.product;
        this.amount = entity.amount;
        this.price = entity.price;
        this.description = entity.description;
        this.date = entity.date;
        this.user = entity.user;
      });
    } else {
      const user = authApi.getUser();
      if (user != null){
        this.user = {
          id: 1,
          title: user.title,
        };
      }
    }
  },
  methods: {
    async save() {
      this.loading = true;

      const newEntity = {
        clientId: this.client.id,
        productId: this.product.id,
        amount: this.amount,
        price: this.price,
        description: this.description,
        date: this.date,
      };

      try {
        if (this.id == 0) {
          await productConsumptionsApi
            .createProductConsumption(newEntity)
            .then(() => {
              this.$router.push({ path: "/product-consumptions" });
            });
        } else {
          await productConsumptionsApi.updateProductConsumption(this.id, newEntity);
          this.$notifySuccess();
        }
      } finally {
        this.loading = false;
      }
    },
    close() {
      if (this.modal) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>